import React from 'react';
import PropTypes from 'prop-types';

export const accountTabs = [
  { key: 'personal', label: 'Dados pessoais e acesso' },
  { key: 'address', label: 'Endereço e comissão' },
  { key: 'bank', label: 'Dados bancários' },
];

const AccountTabs = ({ activeTab, onChange }) => (
  <nav
    className="mt-5 flex items-center gap-8 overflow-x-auto border-b border-grayExtraLight2"
    aria-label="Dados da conta"
  >
    {accountTabs.map((tab) => {
      const active = activeTab === tab.key;

      return (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`whitespace-nowrap border-b-2 px-0 pb-3 text-sm transition-colors ${
            active
              ? 'border-tealMedium font-semibold text-blueDarker'
              : 'border-transparent font-normal text-blueSteel hover:text-blueDarker'
          }`}
        >
          {tab.label}
        </button>
      );
    })}
  </nav>
);

AccountTabs.propTypes = {
  activeTab: PropTypes.oneOf(accountTabs.map((tab) => tab.key)).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AccountTabs;
